import hexToRgba from 'hex-to-rgba'
import styled from 'styled-components'

import { Button as LMFButton, TypeStyle, fromMd } from '@syconium/little-miss-figgy'

export const ImageContentSplitContainer = styled.div`
  margin: 15px 0;

  ${fromMd} {
    display: flex;
  }
`

export const ImageSection = styled.div`
  ${fromMd} {
    box-sizing: border-box;
    padding-inline-end: 24px;
    width: 50%;
  }
`

export const ButtonWrapper = styled.div`
  margin-top: 23px;
`

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean | string
  value: string
}

// 16px is the minimum font size for Apple devices to not zoom on tap
export const StyledTextInput = styled.input<InputProps>`
  ${TypeStyle.css.bodySmall}
  background: ${o => o.theme.color.deprecated.white.primary};
  border-radius: 4px;
  border: 1px solid ${o => (o.hasError ? 'red' : o.theme.color.deprecated.stoneDark)};
  box-sizing: border-box;
  color: ${o => o.theme.color.deprecated.obsidian};
  font-size: 16px;
  font-weight: 600;
  min-height: 42px;
  line-height: 1.25;
  font-family: ${o => o.theme.typography.deprecated.font.family.primary};
  padding: ${o => o.theme.spacing(2)} ${o => o.theme.spacing(4)};
  width: 100%;

  &:focus {
    box-shadow: 0 0 3px 0 ${o => hexToRgba(o.theme.color.deprecated.obsidian, 0.5)};
    outline: 5px solid Highlight;

    @media (-webkit-min-device-pixel-ratio: 0) {
      outline-width: 5px;
      outline-color: -webkit-focus-ring-color;
      outline-style: auto;
    }
  }

  &:read-only {
    color: ${o => o.theme.color.deprecated.obsidianLight};
    font-weight: normal;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &::placeholder {
    color: ${o => o.theme.color.deprecated.obsidianLight};
    font-weight: normal;
    opacity: 0.8;
  }
`

export const ContentSection = styled.div`
  padding: 48px 0;
  text-align: center;

  ${fromMd} {
    box-sizing: border-box;
    padding: 48px 0 48px 24px;
    width: 50%;
  }
`

export const PageTitle = styled.h1<{ isSmall?: boolean }>`
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 28px;
  margin: 21px 0 17px;
  text-align: center;

  ${fromMd} {
    font-size: ${o => (o.isSmall ? '28px' : '36px')};
    letter-spacing: 1.8px;
    line-height: 48px;
    margin: 14px 0 35px;
  }
`

export const PageSubtitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.8px;
  line-height: 24px;
  text-align: center;

  ${fromMd} {
    font-size: 18px;
    letter-spacing: 0.9px;
    line-height: 27px;
  }
`

export const Divider = styled.div`
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
`
export const SecondaryText = styled(TypeStyle.BodySmall)`
  color: ${o => o.theme.color.deprecated.obsidianLight};
`

export const Container = styled.div`
  margin: auto;
  max-width: 1130px;
  padding: 0 16px;
`

export const NavigationWidthContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 455px;
  padding: 0px 16px 16px;
  margin: auto;
  margin-bottom: 94px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const FormButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Button = styled(LMFButton)`
  height: 50px;
`

export const RedButton = styled(Button)`
  color: ${o => o.theme.color.deprecated.red.dark};
`
